import React from 'react';
import { useTranslation } from 'react-i18next';
import BasePage from '../../components/Layout/BasePage';
import MasterDetailLayout from '../../components/Layout/MasterDetailLayout';
import { renderTabLabel as tabLabel } from '../../components/Layout/tabLabel';
import useUrlTab from '../../hooks/useUrlTab';
import PurchaseOrders from './PurchaseOrders';
import Suppliers from './Suppliers';
import ProcurementOverview from './ProcurementOverview';
import Inventory from '../Inventory/Inventory';

function ProcurementPage() {
  const { t } = useTranslation('procurement');
  // Active tab in the URL (?tab=), remembered per module
  const { activeTab, setActiveTab } = useUrlTab(
    'procurement', ['overview', 'purchase-orders', 'materials', 'suppliers'], 'overview'
  );

  const renderTabLabel = (translationKey, shortcutChar) => tabLabel(t(translationKey), shortcutChar);

  const tabs = [
    {
      id: 'overview',
      label: renderTabLabel('tabs.overview', 'o'),
      shortcut: 'o',
      hasSubTabs: false
    },
    {
      id: 'purchase-orders',
      label: renderTabLabel('tabs.purchaseOrders', 'p'),
      shortcut: 'p',
      hasSubTabs: false
    },
    {
      id: 'materials',
      label: renderTabLabel('tabs.materials', 'm'),
      shortcut: 'm',
      hasSubTabs: false
    },
    {
      id: 'suppliers',
      label: renderTabLabel('tabs.suppliers', 's'),
      shortcut: 's',
      hasSubTabs: false
    }
  ];

  // Build toolbars for each tab (all components now handle their own toolbars)


  // Configuration object for MasterDetailLayout
  const config = {
    tabs,
    entities: {},
    toolbars: {
      overview: null,
      'purchase-orders': null, // PurchaseOrders component handles its own toolbar
      materials: null, // Materials component handles its own toolbar
      suppliers: null // Suppliers component handles its own toolbar
    }
  };

  // Render tab content
  const renderTabContent = () => {
    switch (activeTab) {
      case 'purchase-orders':
        return <PurchaseOrders />;

      case 'suppliers':
        return <Suppliers />;

      case 'overview':
        return (
          <div className="tab-content with-padding">
            <ProcurementOverview />
          </div>
        );

      case 'materials':
        return <Inventory />;

      default:
        return null;
    }
  };

  return (
    <BasePage title={t('title')} className="procurement-page">
      <MasterDetailLayout
        config={config}
        activeTab={activeTab}
        onTabChange={setActiveTab}
      >
        {renderTabContent()}
      </MasterDetailLayout>
    </BasePage>
  );
}

export default ProcurementPage;